<template>
  <v-container fluid>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div class="pt-5 pl-md-5 pb-10" style="max-width: 1000px" v-if="!loading">
      <div v-if="list" class="elevation-2 pb-15 mb-16">
        <div
          class="px-5 py-3 subtitle-2 white--text"
          :class="list.active ? 'green' : 'red'"
        >
          {{ $t("Status") }} :
          <span v-if="list.active">{{ $t("Active") }}</span>
          <span v-if="!list.active">{{ $t("Inactive") }}</span>
        </div>
        <div class="pa-5">
          <v-alert dense outlined type="error" v-if="error">
            <ul>
              <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
            </ul>
          </v-alert>
          <h1 class="text-h5 mb-5 mt-5 text-center">
            {{ list.title }}
          </h1>
          <EditTitleDesComponent
            :data="list"
            @getContract="getContract"
            class="float-right"
          />
          <div class="overline grey--text pt-3">
            {{ $t("Description") }}
          </div>
          <div class="body-2" v-html="list.description">
            {{ list.description }}
          </div>
          <div class="overline grey--text pt-3">
            {{ $t("Terms") }}
          </div>
          <v-row v-for="terms in list.terms" :key="terms._id">
            <v-col cols="11">
              <div class="subtitle-2 text-decoration-underline">
                {{ terms.title }}
              </div>
              <div class="subtitle-2 mt-2">
                {{ $t("Estimatedpenalty") }}:
                {{ list.property_id.currency_code }}
                {{ terms.penalty }}
              </div>
              <div class="body-2 mt-2" v-html="terms.description">
                {{ terms.description }}
              </div>
            </v-col>
            <v-col cols="1">
              <v-btn
                class="ma-1"
                x-small
                color="light-blue"
                dark
                fab
                @click="editContractTerm(terms)"
                ><v-icon x-small dark> mdi-pencil </v-icon></v-btn
              >
              <v-btn
                class="ma-1"
                x-small
                color="red"
                dark
                fab
                @click="deleteContractTerm(terms._id)"
                ><v-icon x-small dark> mdi-delete </v-icon></v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
      <!-- edit Terms  dialog -->
      <v-dialog v-model="editDialog" scrollable persistent width="50%">
        <template>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="submit"
            lazy-validation
          >
            <v-card>
              <v-card-title class="light-blue darken-4 white--text">{{
                $t("Edit Term")
              }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text style="max-height: 60vh">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      type="text"
                      outlined
                      :rules="reqRules"
                      v-model="editData.title"
                      v-bind:label="$t('Title')"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      type="text"
                      v-model="editData.penalty"
                      :rules="numberRule"
                      v-bind:label="$t('Estimatedpenalty')"
                      v-bind:hint="$t('EP1')"
                      :suffix="list.property_id.currency_code"
                      persistent-hint
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <vue-editor
                      :editor-toolbar="customToolbar"
                      v-model="editData.description"
                      placeholder="Description"
                      rows="3"
                      max-rows="6"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="pa-5">
                <v-btn color="red" text @click="editDialog = false">
                  {{ $t("Close") }}
                </v-btn>
                <v-btn color="light-blue" dark @click="updateContractTerm()">
                  {{ $t("Save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>
      <v-footer fixed>
        <v-row v-if="list">
          <v-col cols="8" class="offset-md-3">
            <AddNewTermsComponent
              :list="list.property_id"
              @getContract="getContract"
            />
            <SelectTermsComponent @getContract="getContract" />
            <v-btn
              class="mr-2"
              color="light-blue"
              dark
              :to="{
                name: 'PartnerListingViewComponent',
                params: { id: parm }
              }"
            >
              {{ $t("Finish") }}
            </v-btn>
            <v-btn color="red" dark @click="removeContract">
              {{ $t("RemoveContract") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-footer>
    </div>
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import AddNewTermsComponent from "@/components/dashboard/contract/AddNewTermsComponent.vue";
import SelectTermsComponent from "@/components/dashboard/contract/SelectTermsComponent.vue";
import EditTitleDesComponent from "@/components/dashboard/contract/EditTitleDesComponent.vue";
import PartnerService from "@/services/PartnerService";
import { VueEditor } from "vue2-editor";
import swal from "sweetalert";

export default {
  name: "ContractComponent",
  mixins: [timeoutMixin],
  components: {
    EditTitleDesComponent,
    AddNewTermsComponent,
    SelectTermsComponent,
    VueEditor
  },
  data() {
    return {
      parm: this.$route.params.id,
      valid: null,
      editData: {},
      deleteData: {},
      loading: true,
      list: null,
      error: null,
      msg: null,
      editDialog: false,
      reqRules: [value => !!value || this.$t("string719")],
      numberRule: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^\d+(?:\d+)*$/gm;
          return pattern.test(value) || this.$t("string721");
        }
      ],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ]
    };
  },
  created: function() {
    this.getContract();
  },
  methods: {
    updateContractTerm() {
      this.loading = true;
      this.editData.property_id = this.parm;
      PartnerService.updateContractTerms(this.editData)
        .then(() => {
          this.loading = false;
          this.getContract();
          this.editDialog = false;
        })
        .catch(err => {
          this.error = err.response.data.error;
        });
    },
    editContractTerm(val) {
      this.editData = val;
      this.editDialog = true;
    },
    deleteContractTerm(val) {
      swal({
        text: this.$t("string691"),
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.loading = true;
          this.deleteData._id = val;
          this.deleteData.property_id = this.parm;
          PartnerService.deleteContractTerms(this.deleteData)
            .then(() => {
              this.loading = false;
              this.getContract();
            })
            .catch(err => {
              this.error = err.response.data.error;
            });
        }
      });
    },
    getContract() {
      PartnerService.editContract({ property_id: this.parm })
        .then(result => {
          this.list = result.data.contract;
          this.list.terms.sort(function(a, b) {
            return a.order - b.order;
          });
          this.loading = false;
        })
        .catch(err => {
          this.error = err.response.data.error;
        });
    },
    removeContract() {
      swal({
        text: this.$t("string692"),
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.loading = true;
          PartnerService.deleteContract({ property_id: this.parm })
            .then(() => {
              this.loading = false;
              this.$router.push({
                name: "PartnerListingViewComponent",
                params: { id: this.parm }
              });
            })
            .catch(err => {
              this.error = err.response.data.error;
            });
        }
      });
    }
  }
};
</script>

<style>
#vueConfirm .vc-container {
  display: block;
  min-width: 300px;
}
</style>
